import React, { useState } from "react";
import { StyledHeading } from "../../shared/login_and_sign_up/styled";
import { StyledParagraphMedium } from "./set_new_password_content";
import { Button } from "../../components/base_ui/inputs/button";
import { useNavigate } from "react-router-dom";
import { Misuse } from "@carbon/icons-react";
import { snackBarOverrides } from "../../components/base_ui/progress_and_validation/snackbar";
import { useSnackbar } from "baseui/snackbar";

export default function PasswordExpiredContent({
  actionKey,
  title,
  description,
  requestAnotherLinkEndpointUrl,
  onLinkRequestSuccessRedirectUrl,
}: {
  actionKey: string;
  title: string;
  description: React.ReactNode;
  requestAnotherLinkEndpointUrl: string;
  onLinkRequestSuccessRedirectUrl: string;
}) {
  const [isFetching, setIsFetching] = useState(false);
  const navigate = useNavigate();
  const { enqueue } = useSnackbar();

  return (
    <>
      <StyledHeading data-test="password-expired-heading">{title}</StyledHeading>
      <StyledParagraphMedium>{description}</StyledParagraphMedium>
      <Button
        data-test="request-another-link-button"
        isLoading={isFetching}
        onClick={async () => {
          setIsFetching(true);
          const response = await fetch(requestAnotherLinkEndpointUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              action_key: actionKey,
            }),
          });

          const parsedResponse = await response.json();

          setIsFetching(false);

          if (parsedResponse.isSuccess === false) {
            enqueue({
              message:
                "Requesting another link failed, please try again or notify help@mentorcollective.org",
              startEnhancer: () => <Misuse size={24} />,
              overrides: snackBarOverrides,
            });
          } else {
            navigate(onLinkRequestSuccessRedirectUrl);
          }
        }}
      >
        Request Another Link
      </Button>
    </>
  );
}
